import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCarbonImpact from '../reducers/carbon-impact.reducer';

import { selectSelectedMaterial } from './shared.selectors';
import { selectTechInputs } from './inputs.selectors';
import { selectStructuralSteelMassConcrete } from './cost.selectors';

/**
 * Every reducer module exports selector functions, however child reducers
 * have no knowledge of the overall state tree. To make them usable, we
 * need to make new selectors that wrap them.
 *
 * The createSelector function creates very efficient selectors that are memoized and
 * only recompute when arguments change. The created selectors can also be composed
 * together to select different pieces of state.
 */

export const selectCarbonImpactState = createSelector(
  fromFeature.carbonImpactState,
  (state) => state
);

export const selectCapacityOfFarm = createSelector(
  selectCarbonImpactState,
  fromCarbonImpact.selectCapacityOfFarm
);

export const selectCompositeCapacity = createSelector(
  selectCarbonImpactState,
  fromCarbonImpact.selectCompositeCapacity
);

export const selectSelectedSteelType = createSelector(
  selectCarbonImpactState,
  fromCarbonImpact.selectSteelType
);

export const selectCarbonEmissionsData = createSelector(
  selectSelectedSteelType,
  selectSelectedMaterial,
  selectTechInputs,
  selectStructuralSteelMassConcrete,
  (selectedSteelType, material, techInputs, concreteSteelMass) => {
    return {
      selectedSteelType,
      material,
      techInputs,
      concreteSteelMass,
    };
  }
);

export const selectIndirectImpactsData = createSelector(
  selectCapacityOfFarm,
  selectCompositeCapacity,
  (capacityOfFarm, compositeCapacity) => {
    return {
      capacityOfFarm,
      compositeCapacity,
    };
  }
);
